require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 491
// module chunks = 0